import { StrictMode, Suspense, lazy } from 'react';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

import client from '../libs/configs/graphqlClientConfig';
import PartnerConfigProvider from '../libs/providers/PartnerConfigProvider';
import PartnerTagManagerProvider from '../libs/providers/PartnerTagManagerProvider';
import FeatureFlagsProvider from '../libs/providers/FeatureFlagsProvider';
import ThemeProvider from '../libs/providers/ThemeProvider';
import ErrorBoundary from '../libs/providers/ErrorBoundary';
import SnackbarProvider from '../libs/providers/SnackbarProvider';

// @ts-ignore
const CruiseRoutes = lazy(async () => await import('canvas_cruise/CruiseRoutes'));
// @ts-ignore
const RedirectToAmpRoute = lazy(async () => await import('canvas_common_routes/RedirectToAmpRoute'));
// @ts-ignore
const CreditCardDeclineRoute = lazy(async () => await import('canvas_common_routes/CreditCardDeclineRoute'));
// @ts-ignore
const PaymentRoute = lazy(async () => await import('canvas_common_routes/PaymentRoute'));
// @ts-ignore
const SubmissionRoute = lazy(async () => await import('canvas_common_routes/SubmissionRoute'));
// @ts-ignore
const ConfirmationRoute = lazy(async () => await import('canvas_common_routes/ConfirmationRoute'));
// @ts-ignore
const ThreeDSCallbackRoute = lazy(async () => await import('canvas_common_routes/ThreeDSCallbackRoute'));
// @ts-ignore
const AirlineRoutes = lazy(async () => await import('canvas_airline/AirlineRoutes'));
// @ts-ignore
const LabsRoutes = lazy(async () => await import('canvas_labs/LabsRoutes'));
const EcommerceThreeDSCallbackRoute = lazy(
  // @ts-ignore
  async () => await import('canvas_common_routes/EcommerceThreeDSCallbackRoute'),
);
const CreditCardDeclineThreeDSCallbackRoute = lazy(
  // @ts-ignore
  async () => await import('canvas_common_routes/CreditCardDeclineThreeDSCallbackRoute'),
);
// @ts-ignore
const ErrorRoute = lazy(async () => await import('canvas_common_routes/ErrorRoute'));
// @ts-ignore
const UnsubscribeSmsRoute = lazy(async () => await import('canvas_common_routes/UnsubscribeSmsRoute'));
const CreditCardDeclineOutcomeRoute = lazy(
  // @ts-ignore
  async () => await import('canvas_common_routes/CreditCardDeclineOutcomeRoute'),
);

/* note: [new module] import new route there */

const NotFound = () => <div>404 Not Found</div>;

const RedirectRoutesWrapper = () => (
  <Suspense fallback={undefined}>
    <Routes>
      {/* CRUS-1299: Workaround for using AMP cc declined page */}
      <Route path="/offers/partner/:pid/:requestId/card-decline/:offerId/*" element={<RedirectToAmpRoute />} />
      {/* FE-843 temporarily redirect to AMP v1 for splash route */}
      <Route path="/splash/partner/:pid/:requestId" element={<RedirectToAmpRoute />} />
      {/* FE-843 temporarily redirect to AMP v1 for live auction route */}
      <Route path="/live/offer/:pid/:requestId/:offerId/:productId" element={<RedirectToAmpRoute />} />
    </Routes>
  </Suspense>
);

const RoutesWrapper = () => (
  <Suspense fallback={undefined}>
    <Routes>
      <Route path="/payment/partner/:pid/:requestId/callback" element={<ThreeDSCallbackRoute />} />
      <Route path="/payment/partner/:pid/:requestId/ecommerce/callback" element={<EcommerceThreeDSCallbackRoute />} />
      <Route
        path="/payment/partner/:pid/:requestId/card-decline/callback"
        element={<CreditCardDeclineThreeDSCallbackRoute />}
      />
      <Route path="/payment/partner/:pid/:requestId/*" element={<PaymentRoute />} />
      <Route path="/payment/partner/:pid/:requestId/card-decline/outcome" element={<CreditCardDeclineOutcomeRoute />} />
      <Route path="/payment/partner/:pid/:requestId/card-decline/:offerId/*" element={<CreditCardDeclineRoute />} />
      <Route path="/error/partner/:pid/:requestId" element={<ErrorRoute />} />
      <Route path="/unsubscribe/sms/partner/:pid/:requestId" element={<UnsubscribeSmsRoute />} />
      <Route path="/submission/partner/:pid/:requestId/*" element={<SubmissionRoute />} />
      <Route path="/confirmation/partner/:pid/:requestId/*" element={<ConfirmationRoute />} />

      <Route path="/offers/cruise/*" element={<CruiseRoutes />} />
      <Route path="/offers/airline/partner/:pid/*" element={<AirlineRoutes />} />
      <Route path="/offers/labs/*" element={<LabsRoutes />} />

      <Route path="/partner/:pid/404" element={<NotFound />} />
      <Route path="/*" element={<NotFound />} />
      {/* note: [new module] add new route there */}
    </Routes>
  </Suspense>
);

export default function App() {
  return (
    <StrictMode>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <ErrorBoundary>
            <RedirectRoutesWrapper />
            <PartnerConfigProvider>
              <FeatureFlagsProvider>
                <ThemeProvider>
                  <ErrorBoundary>
                    <SnackbarProvider>
                      <PartnerTagManagerProvider>
                        <RoutesWrapper />
                      </PartnerTagManagerProvider>
                    </SnackbarProvider>
                  </ErrorBoundary>
                </ThemeProvider>
              </FeatureFlagsProvider>
            </PartnerConfigProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </ApolloProvider>
    </StrictMode>
  );
}
